import { Timestamp, TranslateFunction, WeekDays } from '@griply/types';

import { getScheduleLabel } from './get-schedule-label';
import { parseRruleAndCountToSchedule } from './schedules/parse-rrule-and-count-to-schedule';

// A recurring *instance* carries no rrule of its own — the rule lives on the series master —
// so a null rrule is "nothing to say here", not "does not repeat".
export const getCalendarEventRepeatLabel = (
  rrule: string | null,
  today: Timestamp,
  t: TranslateFunction,
  weekStartsOn?: WeekDays,
): string | null => {
  if (!rrule) {
    return null;
  }

  return getScheduleLabel(
    parseRruleAndCountToSchedule(rrule, null, today),
    t,
    true,
    weekStartsOn,
  );
};
